import { defineStore } from "pinia";
import adminApi, { setAuthToken } from "@/utils/adminApi"; // Import ตัวที่เราสร้าง

export const useAdminAuthStore = defineStore("adminAuth", {
  state: () => ({
    token: localStorage.getItem("admin_token") || null,
    user: JSON.parse(localStorage.getItem("admin_user")) || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
  },

  actions: {
    async login(username, password) {
      try {
        // Debug: ดูว่าค่ามาถึง Store หรือไม่ (กด F12 ดู Console)
        console.log("🔐 Store Attempting Login:", { username, password });

        // ส่ง Request ผ่าน adminApi
        // URL ไม่ต้องใส่ /api/admin นำหน้าซ้ำ ถ้า adminApi หรือ Proxy ตั้งไว้แล้ว
        // แต่เพื่อความชัวร์ ใส่ path เต็ม relative กับ domain ไปเลย
        const response = await adminApi.post("/api/admin/auth/login", {
          username: username,
          password: password,
        });

        console.log("✅ Login Response:", response.data); // Debug

        const { token, user } = response.data;

        // อัปเดต State
        this.token = token;
        this.user = user;

        // บันทึกลง LocalStorage
        localStorage.setItem("admin_token", token);
        localStorage.setItem("admin_user", JSON.stringify(user));

        // ตั้งค่า Header สำหรับ Request ครั้งต่อไปทันที
        setAuthToken(token);

        return true;
      } catch (error) {
        console.error(
          "❌ Login Failed:",
          error.response?.data || error.message
        );
        throw error.response?.data?.message || "เข้าสู่ระบบไม่สำเร็จ";
      }
    },

    logout() {
      this.token = null;
      this.user = null;
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      setAuthToken(null); // ลบ Header
      // router.push('/login') // ให้ View จัดการ redirect เอง หรือใส่ที่นี่ก็ได้

      // บังคับไปหน้า Login และรีเฟรชหน้าจอเพื่อเคลียร์ State ทั้งหมด (วิธีบ้านๆ แต่ชัวร์สุด)
      window.location.href = "/login";
    },
  },
});
